import React from 'react';

import { getVideoCover, isLandscape, isVideo } from '@libs/NwUtils';

import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

/**
 * Miniatura d'archivio. Il tap seleziona, il pulsante d'angolo apre l'anteprima:
 * sul telefono il tap deve avere un solo significato.
 */
const MobilePickerThumb = ({ document, isInBook, orderNumber, onToggle, onPreview }) => {
    const video = isVideo(document);
    const thumbnailUrl = video ? getVideoCover(document) : document.Thumbnail && document.Thumbnail.Url;

    let thumbClasses = 'picker-thumb';
    if (isLandscape(document)) {
        thumbClasses += ' landscape';
    }
    if (isInBook) {
        thumbClasses += ' in-book';
    } else if (orderNumber) {
        thumbClasses += ' selected';
    }

    const mediaLabel = `${video ? 'Video' : 'Photo'} ${document.ID}`;

    const handlePreview = (event) => {
        event.stopPropagation();
        onPreview(document);
    };

    return (
        <div className={thumbClasses}>
            <img src={thumbnailUrl} alt={mediaLabel} />
            <button
                type="button"
                className="thumb-select"
                disabled={isInBook}
                aria-pressed={Boolean(orderNumber)}
                aria-label={isInBook ? `${mediaLabel}, already in this book` : mediaLabel}
                onClick={() => onToggle(document)}
            />
            {orderNumber ? <span className="thumb-order">{orderNumber}</span> : null}
            {isInBook && <span className="thumb-inbook">In book</span>}
            {!isInBook && (
                <button type="button" className="thumb-preview" aria-label={`Preview ${mediaLabel}`} onClick={handlePreview}>
                    <NwIcon icon={video ? byPrefixAndName.fass['play'] : byPrefixAndName.fasl['eye']} />
                </button>
            )}
        </div>
    );
};

export default MobilePickerThumb;
